const styles = theme => ({
  footerButton: {
    margin: '0 5px',
    background: 'transparent',
    border: 'none',
    height: 51,
    width: 41,
    '&:hover, &:focus': {
      backgroundColor: 'transparent',
      borderBottom: '#D7A774 3px solid',
    },
  },
  buttonIcon: {
    fontSize: 35,
  },
  historyDrawer: {
    // clipPath: 'polygon(9% 0, 54% 0, 60% 21%, 95% 21%, 100% 39%, 100% 100%, 0 100%, 0 28%);',
    '& .ant-drawer-content': {
      background: '#22232F',
      opacity: 0.9,
      overflow: 'hidden',
      '& .ant-drawer-header': {
        backgroundColor: 'transparent',
        borderBottom: 'none',
        display: 'none',
      },
      '& .ant-drawer-body': {
        padding: 0,
        backgroundColor: 'transparent',
        color: 'white',
        overflow: 'hidden',
      },
    },
  },
  historyDrawerContainer: {
    width: '100vw',
  },
});

export default styles;
